export default {
    'preferredExhibitors': 'Hot',
    'invitationNotifyTips' : 'Please add contacts',
    'tips' : 'Tips',
    'product': 'Products viewed',
    'exhibitor': 'Exhibitors viewed',
    'person': 'Visitors viewed',
    'userAccountId': 'User ID cannot be blank',
    'exhibitorNoline': 'Exhibitor is offline'
  }
  